module.exports = __webpack_public_path__ + "static/img/hongbao.54c43f6.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/hongbao.png
// module id = dqWr
// module chunks = 15